import React, { Component } from 'react';
import { FaRegArrowAltCircleLeft } from "react-icons/fa";

// I have to update this url to the prod URL when we go live
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBackButton: true
    }
  }

  componentWillMount(){
    let currentURL = window.location.href 

    if(currentURL === "https://daltonwemer.com/home" || currentURL === "https://daltonwemer.com/" || currentURL === "http://localhost:3000/home" || currentURL === "http://localhost:3000/"){
      this.setState({
        showNav: false
      })
    }else{
      this.setState({
        showNav: true
      })
    }
  }

  render() {
    return (
    <a href="/home">
      <div  
        className="header"
        style={{backgroundColor: this.props.backgroundColor}}
      >
          <a href="/home" class="back-arrow">
            <FaRegArrowAltCircleLeft
              color={this.props.textColor}
              class="back-button"
              size={'24px'}
            />
          </a>
            <div class="header-job-and-years" style={{color: this.props.textColor}}>
              {/* <h2 className="header-title" style={{color: this.props.textColor}}>{this.props.title}</h2>
              <p class="job-title">{this.props.jobTitle}</p>
              <p class="years-at-role">{this.props.yearsAtRole}</p> */}
              <h2 className="header-title" style={{color: this.props.textColor}}>Back To Work Showcase</h2>
            </div>
          </div>
    </a>
    
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js